import { AnimatePresence, motion } from "framer-motion";
import { ExternalLink, MessageCircle, X } from "lucide-react";
import { PHONE_NUMBER, WHATSAPP_URL } from "@/config/site";

const QR_SOURCE = `https://api.qrserver.com/v1/create-qr-code/?size=320x320&data=${encodeURIComponent(WHATSAPP_URL)}`;

export default function WhatsAppAccessModal({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[80] bg-charcoal/70 p-4 backdrop-blur-[1px]"
          onClick={onClose}
          role="presentation"
        >
          <motion.div
            initial={{ opacity: 0, y: 18, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 14, scale: 0.98 }}
            transition={{ duration: 0.2 }}
            className="mx-auto mt-8 w-full max-w-md rounded-3xl border border-stone-200 bg-white p-5 shadow-[0_24px_60px_rgba(0,0,0,0.35)]"
            onClick={(event) => event.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="WhatsApp Access"
          >
            <div className="mb-4 flex items-start justify-between gap-4">
              <div>
                <p className="font-accent text-[11px] uppercase tracking-[0.18em] text-accent-gold">Desktop Access</p>
                <h3 className="mt-1 font-heading text-2xl text-charcoal">Open WhatsApp Fast</h3>
                <p className="mt-2 font-body text-sm text-stone-600">
                  Scan the QR code with your phone or use the number below.
                </p>
              </div>
              <button
                type="button"
                onClick={onClose}
                className="rounded-full border border-stone-200 p-2 text-stone-500 transition-colors hover:text-charcoal"
                aria-label="Close WhatsApp modal"
              >
                <X size={16} strokeWidth={1.8} />
              </button>
            </div>

            <div className="rounded-2xl border border-stone-200 bg-stone-50 p-4">
              <img
                src={QR_SOURCE}
                alt="WhatsApp QR code"
                className="mx-auto h-52 w-52 rounded-xl border border-stone-200 bg-white p-2"
              />
              <p className="mt-4 text-center font-body text-sm text-stone-600">WhatsApp number</p>
              <p className="mt-1 text-center font-body text-lg font-semibold text-charcoal">{PHONE_NUMBER}</p>
            </div>

            <div className="mt-4 grid grid-cols-2 gap-3">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-4 py-3 font-body text-sm font-medium text-white transition-colors hover:bg-[#20BD5A]"
              >
                Open Web
                <ExternalLink size={15} strokeWidth={1.7} />
              </a>
              <button
                type="button"
                onClick={onClose}
                className="inline-flex items-center justify-center gap-2 rounded-full border border-stone-300 bg-white px-4 py-3 font-body text-sm font-medium text-charcoal transition-colors hover:bg-stone-50"
              >
                Continue
                <MessageCircle size={15} strokeWidth={1.7} />
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
